module.exports = __webpack_public_path__ + "img/ic-optimisation.5c72670d.svg";